import { CustomAppLayout } from '../../layout';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import React, { useEffect, useMemo, useState } from 'react';
import { useRouter } from '../../router';
//import { useStore } from '../store';
import { useGlobalState } from '../../../context/GlobalStateContext';


//import { useStoreAdmin } from '../../../context/useStoreAdmin';

import { Alert, Button, Checkbox, Container, Form, FormField, Input, Link, SpaceBetween, TokenGroup } from '@cloudscape-design/components';
import Header from "@cloudscape-design/components/header";
import { addHours, format, parse } from 'date-fns';
import DPModal from '../../../../components/DPModal';
import Favorites from '../../../../components/extras/Favorites';
import SelectAirline from '../../../../components/selects/SelectAirline';
import SelectAirport from '../../../../components/selects/SelectAirport';
import SelectGTM from '../../../../components/selects/SelectGMT';
import { fetchWithWatch } from '../../../../hooks/fetchWithWatch';
import { ItemAirline, ItemAirport, ItemConfigAirport, scrollToTop } from '../../../../resources/types';
import { addNotification, buildBreadcrumbItems, getCookie, getUrlVersion, isEmail, setData, setLoading } from '../../../commons/functions';

export const ConfigAirportPage = () => {
    //const storeAdmin = useStoreAdmin();
    const [direction, setDirection] = useState("")
    const [inputEmail, setInputEmail] = useState("")
    const [airport, setAirport] = useState<ItemAirport>({} as ItemAirport);
    const [airports, setAirports] = useState<ItemAirport[]>([]);
    const [airlines, setAirlines] = useState<ItemAirline[]>([]);
    const { navigate } = useRouter();
    const { idAirport, menu } = useGlobalState();

    useEffect(() => {
        if (idAirport) {
            setTimeout(() => {
                handleGetAirport();
            }, 0)
        }
    }, [idAirport]);


    const handleUpdateAirport = async () => {
        try {
            setLoading(true)
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'JWT': getCookie("JWT"),
                    'x-routing': '/private/config/airport/update',
                },
                body: JSON.stringify(airport),

            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const dataWeb = await response.json();
            scrollToTop();
            if (dataWeb.code == 0) {
                addNotification(dataWeb.status, 'success', setData);
                setAirport(dataWeb.airport);
                if (dataWeb.airports) {
                    setAirports(dataWeb.airports);
                }
                if (dataWeb.airlines) {
                    setAirlines(dataWeb.airlines);
                }
            } else {
                addNotification(dataWeb.status, 'error', setData);
            }
        } catch (error: any) {
            addNotification(`Error al contactar el servidor: ${error.message}`, 'error', setData);
        } finally {
            setLoading(false)
        }
    };
    const handleGetAirport = async () => { // Make the function async

        try {
            setLoading(true)
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'JWT': getCookie("JWT"),
                    'x-routing': '/private/config/airport/get',
                },
                body: JSON.stringify({}),

            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const dataWeb = await response.json();
            if (dataWeb.code == 0) {
                setAirport(dataWeb.airport);
                if (dataWeb.airports) {
                    setAirports(dataWeb.airports);
                }
                if (dataWeb.airlines) {
                    setAirlines(dataWeb.airlines);
                }
            } else {
                addNotification(dataWeb.status, 'error', setData);
            }
        } catch (error: any) {
            addNotification(`Error al contactar el servidor: ${error.message}`, 'error', setData);
        } finally {
            setLoading(false)
        }
    };

    useEffect(() => {
        handleGetAirport();
    }, []);

    const scheduledDate = useMemo(() => {
        const date = airport.GMTNextSync ? parse(airport.GMTNextSync, "dd-MM-yyyy", new Date()) : null;
        if (date) {
            return addHours(date, (airport.GMT || 0) * -1);
        }
        return null;
    }, [airport.GMTNextSync, airport.GMTNextValue]);
    return (
        <CustomAppLayout
            toolsHide={true}
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <SpaceBetween size="s">
                    <Header variant="h1" actions={<Favorites />} description={airport.city ? `${airport.city}` : ""}>Editar aeropuerto {airport.IATA ? <em>{airport.IATA}</em> : ""}</Header>
                    {airport && airport.idAirport && (
                        <Form actions={
                            <SpaceBetween size="m" direction='horizontal'>
                                <Button variant="primary" onClick={() => {
                                    console.log(airport)
                                    handleUpdateAirport();
                                }}>Actualizar</Button>
                            </SpaceBetween>}>
                            <SpaceBetween size="m" direction='vertical'>
                                <Container header={<Header variant="h2">Huso horario</Header>}>
                                    <SpaceBetween size="m" direction='horizontal'>
                                        <FormField label="Zona GMT actual"
                                            description="Diferencial horario respecto a GMT."
                                            constraintText="Valor en horas"
                                        >
                                            <SelectGTM value={airport.GMT} onSelect={(GMT) => {
                                                setAirport(prev => ({
                                                    ...prev,
                                                    GMT: GMT,
                                                } as ItemAirport)); // <--- Cast to the state's root type

                                            }} />
                                        </FormField>
                                        <FormField label="Próxima Zona GMT"
                                            description="Actualizar GMT automáticamente al próximo cambio de horario."
                                            constraintText="Valor en horas"
                                        >
                                            <div style={{ width: 200 }}>
                                                <SelectGTM value={airport.GMTNextValue} onSelect={(GMTNextValue) => {
                                                    setAirport(prev => ({
                                                        ...prev,
                                                        GMTNextValue: GMTNextValue,
                                                    } as ItemAirport)); // <--- Cast to the state's root type

                                                }} />
                                            </div>
                                        </FormField>
                                        <FormField label="Fecha de cambio"
                                            description="Fecha en la cual debe ocurrir este cambio."
                                            constraintText="Dejar en blanco para no considerar el cambio automático de GMT."
                                        >
                                            <SpaceBetween size="m" direction='horizontal'>
                                                <DPModal date={airport.GMTNextSync || ""}
                                                    start={new Date()}
                                                    onConfirm={(dateSelected) => {
                                                        setAirport(prev => ({
                                                            ...prev,
                                                            GMTNextSync: dateSelected,
                                                        } as ItemAirport)); // <--- Cast to the state's root type
                                                    }} />
                                            </SpaceBetween>
                                        </FormField>
                                        {airport.GMTNextSync && airport.GMTNextSync !== "" && scheduledDate !== null && airport.GMTNextValue !== undefined && (
                                            <Alert type="info"
                                                header="Programación de cambio de huso horario"
                                            >
                                                El día <strong>{scheduledDate ? format(scheduledDate, "dd-MM-yyyy") : "--/--/----"}</strong> a las <strong>{scheduledDate ? format(scheduledDate, "HH:mm") : "--:--"}</strong> horas UTC, el nuevo huso horario será GMT <strong>{airport.GMTNextValue >= 0 ? `+${airport.GMTNextValue}` : `${airport.GMTNextValue}`}</strong>.
                                            </Alert>
                                        )}

                                    </SpaceBetween>
                                </Container>
                                <Container header={<Header variant="h2">SIC-NS</Header>}>
                                    <SpaceBetween size="m" direction='vertical'>
                                        <SpaceBetween size="m" direction='horizontal'>
                                            <Checkbox checked={airport.jsonConfig?.SICNS?.publishToSICNS === 1} onChange={e => {
                                                const isChecked = e.detail.checked ? 1 : 0;
                                                console.log(airport)
                                                setAirport(prev => ({
                                                    ...prev,
                                                    jsonConfig: {
                                                        ...prev.jsonConfig,
                                                        SICNS: {
                                                            ...(prev.jsonConfig?.SICNS || {}),
                                                            publishToSICNS: isChecked
                                                        }
                                                    } as ItemConfigAirport // Tell TS "Trust me, this matches the interface"

                                                }));
                                            }}
                                                description={<>Habilita la actualización de vuelos desde todas las pantallas de FIDS hacia SIC-NS. Para deshabilitar esta función desde un display en particular, refierase a la <Link variant="info" onClick={() => navigate("config/displays")}>configuración de displays</Link></>}
                                            >Actualizaciones SIC-NS</Checkbox>
                                        </SpaceBetween>
                                        {airport?.jsonConfig?.SICNS?.publishToSICNS === 1 && (
                                            <FormField label="API Key">
                                                <Input
                                                    value={airport.jsonConfig?.SICNS?.apiKey || ""}
                                                    onChange={({ detail }) => {
                                                        const apiKey = detail.value;
                                                        setAirport(prev => ({
                                                            ...prev,
                                                            jsonConfig: {
                                                                ...prev.jsonConfig,
                                                                SICNS: {
                                                                    ...(prev.jsonConfig?.SICNS || {}),
                                                                    apiKey: apiKey
                                                                }
                                                            } as ItemConfigAirport
                                                        }));
                                                    }}
                                                />
                                            </FormField>
                                        )}
                                    </SpaceBetween>
                                </Container>
                                <Container header={<Header variant="h2">RMS</Header>}>
                                    <SpaceBetween size="m" direction='vertical'>
                                        <SpaceBetween size="m" direction='horizontal'>
                                            <Checkbox checked={airport.jsonConfig?.RMS?.enableRMSUpdate === 1} onChange={e => {
                                                const isChecked = e.detail.checked ? 1 : 0;
                                                console.log(airport)
                                                setAirport(prev => ({
                                                    ...prev,
                                                    jsonConfig: {
                                                        ...prev.jsonConfig,
                                                        RMS: {
                                                            ...(prev.jsonConfig?.RMS || {}),
                                                            enableRMSUpdate: isChecked
                                                        }
                                                    } as ItemConfigAirport // Tell TS "Trust me, this matches the interface"

                                                }));
                                            }}
                                                description={"Se permite la actualización de vuelos desde el RMS hacia FIDS."}
                                            >Habilitar actualizaciones RMS</Checkbox>

                                            <Checkbox checked={airport.jsonConfig?.status?.enableUpdate === 1} onChange={e => {
                                                const isChecked = e.detail.checked ? 1 : 0;
                                                console.log(airport)
                                                setAirport(prev => ({
                                                    ...prev,
                                                    jsonConfig: {
                                                        ...prev.jsonConfig,
                                                        status: {
                                                            ...(prev.jsonConfig?.status || {}),
                                                            enableUpdate: isChecked
                                                        }
                                                    } as ItemConfigAirport // Tell TS "Trust me, this matches the interface"

                                                }));
                                            }}
                                                description={"Se permite la actualización de vuelos por cumplimiento de horarios."}
                                            >Habilitar actualizaciones de estados</Checkbox>

                                        </SpaceBetween>
                                        <div style={{ width: 200 }}>
                                            <FormField label="Umbral de reporte"
                                                description="Tiempo en minutos para considerar un vuelo como retrasado desde el reporte del RMS."
                                                constraintText="Valor en minutos."
                                            >
                                                <Input type="number" value={airport.jsonConfig?.RMS?.thresholdReportTime?.toString() || "0"} onChange={e => {

                                                    const parsedValue = parseInt(e.detail.value, 10);
                                                    const finalValue = isNaN(parsedValue) ? 0 : parsedValue.toString();
                                                    setAirport(prev => ({
                                                        ...prev,
                                                        jsonConfig: {
                                                            ...prev.jsonConfig,
                                                            RMS: {
                                                                ...(prev.jsonConfig?.RMS || {}),
                                                                thresholdReportTime: finalValue
                                                            }
                                                        } as ItemConfigAirport // Tell TS "Trust me, this matches the interface"
                                                    }));
                                                }} />
                                            </FormField>
                                        </div>
                                        <FormField label="Usuarios"><Input
                                            value={inputEmail}
                                            onChange={({ detail }) => setInputEmail(detail.value)}
                                            inputMode="email"
                                            invalid={inputEmail.trim() !== "" && !isEmail(inputEmail.trim())}
                                            onKeyDown={event => {
                                                if (event.detail.keyCode === 13 && isEmail(inputEmail.trim())) {
                                                    const currentUsers = airport.jsonConfig?.RMS?.reportingUsers || [];

                                                    // Prevent duplicates
                                                    if (!currentUsers.find(t => t === inputEmail.trim())) {
                                                        const newTokens = [...currentUsers, inputEmail.trim()];

                                                        setAirport(prev => ({
                                                            ...prev,
                                                            jsonConfig: {
                                                                ...prev.jsonConfig,
                                                                RMS: {
                                                                    ...(prev.jsonConfig?.RMS || {}),
                                                                    reportingUsers: newTokens
                                                                }
                                                            } as ItemConfigAirport
                                                        }));
                                                    }
                                                    setInputEmail(""); // Clear input after Enter
                                                }
                                            }}
                                            placeholder="Escriba y presione Enter para agregar email"
                                        />

                                            <TokenGroup
                                                onDismiss={({ detail: { itemIndex } }) => {
                                                    const newTokens = [...airport.jsonConfig?.RMS?.reportingUsers || []];
                                                    newTokens.splice(itemIndex, 1);
                                                    setAirport(prev => ({
                                                        ...prev,
                                                        jsonConfig: {
                                                            ...prev.jsonConfig,
                                                            RMS: {
                                                                ...(prev.jsonConfig?.RMS || {}),
                                                                reportingUsers: newTokens
                                                            }
                                                        } as ItemConfigAirport // Tell TS "Trust me, this matches the interface"
                                                    }));
                                                }}
                                                items={
                                                    airport.jsonConfig?.RMS?.reportingUsers?.map(user => ({ label: user })) || []
                                                }
                                            />
                                        </FormField>
                                    </SpaceBetween>
                                </Container>
                                <Container header={<Header variant="h2">Aeropuerto</Header>}>
                                    <SpaceBetween size="m" direction='vertical'>
                                        <FormField label="Aeropuertos asociados"
                                            info={`(${airport.jsonConfig?.airports?.length}/${airports.length})`}
                                            description="Seleccione los aeropuertos que estarán asociados a este aeropuerto para efectos de utilización.">
                                            <SelectAirport single={false}
                                                filteringType='auto'
                                                hideTokens
                                                dataset={airports}
                                                value={airport.jsonConfig?.airports || []}
                                                onSelect={(airports) => {
                                                    setAirport(prev => ({
                                                        ...prev,
                                                        jsonConfig: {
                                                            ...prev.jsonConfig,
                                                            airports: airports
                                                        } as ItemConfigAirport
                                                    }));
                                                }}
                                            />
                                        </FormField>
                                        <FormField label="Aerolineas asociados"
                                            info={`(${airport.jsonConfig?.airlines?.length}/${airlines.length})`}
                                            description="Seleccione las aerolineas que estarán asociadas a este aeropuerto para efectos de utilización.">
                                            <SelectAirline single={false}
                                                filteringType='auto'
                                                hideTokens
                                                dataset={airlines}
                                                value={airport.jsonConfig?.airlines || []}
                                                onSelect={(airlines) => {
                                                    setAirport(prev => ({
                                                        ...prev,
                                                        jsonConfig: {
                                                            ...prev.jsonConfig,
                                                            airlines: airlines
                                                        } as ItemConfigAirport
                                                    }));
                                                }}
                                            />
                                        </FormField>
                                    </SpaceBetween>
                                </Container>
                                <SpaceBetween size="m" direction='horizontal'>

                                </SpaceBetween>


                                <SpaceBetween size="m" direction='horizontal'>
                                </SpaceBetween>



                            </SpaceBetween>
                        </Form>
                    )}
                </SpaceBetween>

            }
        />
    )
};
